const NewFinancialYearFields = [
  {
    id: Math.random() * 10,
    name: "New_Financial_Year",
    fields: [
      {
        id: Math.random() * 10,
        name: "From_Date",
        label: "From Date",
        type: "Date",
        autoFocus:true,
      },
      {
        id: Math.random() * 10,
        name: "To_Date",
        label: "To Date",
        type: "Date",
      },
    ],
  },
];

export { NewFinancialYearFields };
